// extracted by mini-css-extract-plugin
export var attributions = "socialCard-module--attributions--d98f3";
export var card = "socialCard-module--card--00634";
export var cardContents = "socialCard-module--cardContents--b12d7";
export var dark = "socialCard-module--dark--fb591";
export var isPlaying = "socialCard-module--isPlaying--7f87f";
export var light = "socialCard-module--light--43539";
export var logo = "socialCard-module--logo--90c76";
export var playButton = "socialCard-module--playButton--ff890";
export var playButtonCanvas = "socialCard-module--playButtonCanvas--41503";
export var playButtonTimer = "socialCard-module--playButtonTimer--33a5c";
export var playButtonWrapper = "socialCard-module--playButtonWrapper--ec5c8";
export var quote = "socialCard-module--quote--a1a10";
export var tag = "socialCard-module--tag--1b521";
export var videoBlur = "socialCard-module--videoBlur--97a3f";
export var videoContainer = "socialCard-module--videoContainer--6c0ae";
export var videoPlayer = "socialCard-module--videoPlayer--5c928";
export var videoPoster = "socialCard-module--videoPoster--14c0b";